type IconProps = React.HTMLAttributes<SVGElement>;

export const IllustrationMultipleCompartments = (props: IconProps) => {
	return (
		<svg width="342" height="240" viewBox="0 0 342 240" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect x="0.5" y="8.5" width="341" height="17" fill="white" stroke="#31323A" />
			<path d="M340.941 26.25L333.941 29.75H8.05859L1.05859 26.25H340.941Z" fill="#31323A" stroke="#31323A" strokeWidth="0.5" />
			<rect x="8.5" y="30.5" width="325" height="209" fill="white" />
			<rect x="8.5" y="30.5" width="325" height="209" stroke="#31323A" />
			<mask id="path-4-inside-1_250_12613" fill="white">
				<path d="M16 38H78V74H16V38Z" />
			</mask>
			<path d="M16 38H78V74H16V38Z" fill="white" />
			<path
				d="M16 38V37.5H15.5V38H16ZM16 38V38.5H78V38V37.5H16V38ZM16 74H16.5V38H16H15.5V74H16Z"
				fill="#31323A"
				mask="url(#path-4-inside-1_250_12613)"
			/>
			<mask id="path-6-inside-2_250_12613" fill="white">
				<path d="M78 38H140V74H78V38Z" />
			</mask>
			<path d="M78 38H140V74H78V38Z" fill="white" />
			<path
				d="M78 38V37.5H77.5V38H78ZM78 38V38.5H140V38V37.5H78V38ZM78 74H78.5V38H78H77.5V74H78Z"
				fill="#31323A"
				mask="url(#path-6-inside-2_250_12613)"
			/>
			<mask id="path-8-inside-3_250_12613" fill="white">
				<path d="M140 38H202V74H140V38Z" />
			</mask>
			<path d="M140 38H202V74H140V38Z" fill="white" />
			<path
				d="M140 38V37.5H139.5V38H140ZM140 38V38.5H202V38V37.5H140V38ZM140 74H140.5V38H140H139.5V74H140Z"
				fill="#31323A"
				mask="url(#path-8-inside-3_250_12613)"
			/>
			<mask id="path-10-inside-4_250_12613" fill="white">
				<path d="M202 38H264V74H202V38Z" />
			</mask>
			<path d="M202 38H264V74H202V38Z" fill="white" />
			<path
				d="M202 38V37.5H201.5V38H202ZM202 38V38.5H264V38V37.5H202V38ZM202 74H202.5V38H202H201.5V74H202Z"
				fill="#31323A"
				mask="url(#path-10-inside-4_250_12613)"
			/>
			<mask id="path-12-inside-5_250_12613" fill="white">
				<path d="M264 38H326V74H264V38Z" />
			</mask>
			<path d="M264 38H326V74H264V38Z" fill="white" />
			<path
				d="M264 38V37.5H263.5V38H264ZM326 38H326.5V37.5H326V38ZM264 38V38.5H326V38V37.5H264V38ZM326 38H325.5V74H326H326.5V38H326ZM264 74H264.5V38H264H263.5V74H264Z"
				fill="#31323A"
				mask="url(#path-12-inside-5_250_12613)"
			/>
			<mask id="path-14-inside-6_250_12613" fill="white">
				<path d="M16 74H78V110H16V74Z" />
			</mask>
			<path d="M16 74H78V110H16V74Z" fill="white" />
			<path
				d="M16 74V73.5H15.5V74H16ZM16 74V74.5H78V74V73.5H16V74ZM16 110H16.5V74H16H15.5V110H16Z"
				fill="#31323A"
				mask="url(#path-14-inside-6_250_12613)"
			/>
			<mask id="path-16-inside-7_250_12613" fill="white">
				<path d="M78 74H140V110H78V74Z" />
			</mask>
			<path d="M78 74H140V110H78V74Z" fill="#DBFFC8" />
			<path
				d="M78 74V73.5H77.5V74H78ZM78 74V74.5H140V74V73.5H78V74ZM78 110H78.5V74H78H77.5V110H78Z"
				fill="#31323A"
				mask="url(#path-16-inside-7_250_12613)"
			/>
			<mask id="path-18-inside-8_250_12613" fill="white">
				<path d="M140 74H202V110H140V74Z" />
			</mask>
			<path d="M140 74H202V110H140V74Z" fill="white" />
			<path
				d="M140 74V73.5H139.5V74H140ZM140 74V74.5H202V74V73.5H140V74ZM140 110H140.5V74H140H139.5V110H140Z"
				fill="#31323A"
				mask="url(#path-18-inside-8_250_12613)"
			/>
			<mask id="path-20-inside-9_250_12613" fill="white">
				<path d="M202 74H264V110H202V74Z" />
			</mask>
			<path d="M202 74H264V110H202V74Z" fill="#DBFFC8" />
			<path
				d="M202 74V73.5H201.5V74H202ZM202 74V74.5H264V74V73.5H202V74ZM202 110H202.5V74H202H201.5V110H202Z"
				fill="#31323A"
				mask="url(#path-20-inside-9_250_12613)"
			/>
			<path
				d="M218.165 84.1832C218.088 84.1472 218 84.2035 218 84.2886V99.6912C218 99.7358 218.026 99.7765 218.066 99.7959L232.728 106.87C232.805 106.908 232.895 106.851 232.895 106.766V91.1336C232.895 91.0884 232.868 91.0473 232.828 91.0282L218.165 84.1832Z"
				fill="#BDFF9C"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M232.994 91.1407C232.954 91.16 232.928 91.2009 232.928 91.2459V106.819C232.928 106.904 233.015 106.96 233.092 106.925L247.754 100.231C247.795 100.212 247.822 100.171 247.822 100.126L247.998 84.2274C247.999 84.1415 247.91 84.0843 247.832 84.121L232.994 91.1407Z"
				fill="white"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M218.078 84.1032C218.061 84.1117 218.061 84.1369 218.078 84.1452L232.918 91.1485C232.924 91.1515 232.931 91.1515 232.938 91.1485L247.956 84.05C247.973 84.0416 247.973 84.0162 247.955 84.0079L232.938 77.0046C232.931 77.0017 232.924 77.0017 232.918 77.0047L218.078 84.1032Z"
				fill="white"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M223.95 81.3166L239.031 88.2948L239.094 95.4319L242.543 93.681L242.566 86.6076L227.662 79.5669L223.95 81.3166Z"
				fill="#DBFFC8"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M239.032 88.2929L242.567 86.6057L242.543 93.6791L239.095 95.43L239.032 88.2929Z"
				fill="#BDFF9C"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<mask id="path-27-inside-10_250_12613" fill="white">
				<path d="M264 74H326V110H264V74Z" />
			</mask>
			<path d="M264 74H326V110H264V74Z" fill="white" />
			<path
				d="M264 74V73.5H263.5V74H264ZM326 74H326.5V73.5H326V74ZM264 74V74.5H326V74V73.5H264V74ZM326 74H325.5V110H326H326.5V74H326ZM264 110H264.5V74H264H263.5V110H264Z"
				fill="#31323A"
				mask="url(#path-27-inside-10_250_12613)"
			/>
			<path
				d="M94.1655 84.1832C94.0884 84.1472 94 84.2035 94 84.2886V99.6912C94 99.7358 94.0255 99.7765 94.0657 99.7959L108.728 106.87C108.805 106.908 108.895 106.851 108.895 106.766V91.1336C108.895 91.0884 108.868 91.0473 108.828 91.0282L94.1655 84.1832Z"
				fill="#BDFF9C"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M108.994 91.1407C108.954 91.16 108.928 91.2009 108.928 91.2459V106.819C108.928 106.904 109.015 106.96 109.092 106.925L123.754 100.231C123.795 100.212 123.822 100.171 123.822 100.126L123.998 84.2274C123.999 84.1415 123.91 84.0843 123.832 84.121L108.994 91.1407Z"
				fill="white"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M94.0783 84.1032C94.0607 84.1117 94.0607 84.1369 94.0784 84.1452L108.918 91.1485C108.924 91.1515 108.931 91.1515 108.938 91.1485L123.956 84.05C123.973 84.0416 123.973 84.0162 123.955 84.0079L108.938 77.0046C108.931 77.0017 108.924 77.0017 108.918 77.0047L94.0783 84.1032Z"
				fill="white"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M99.9502 81.3166L115.031 88.2948L115.094 95.4319L118.543 93.681L118.566 86.6076L103.662 79.5669L99.9502 81.3166Z"
				fill="#DBFFC8"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M115.032 88.2929L118.567 86.6057L118.543 93.6791L115.095 95.43L115.032 88.2929Z"
				fill="#BDFF9C"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<rect width="310" height="60" transform="translate(16 110)" fill="white" />
			<mask id="path-34-inside-11_250_12613" fill="white">
				<path d="M16 110H78V120H16V110Z" />
			</mask>
			<path d="M16 110H78V120H16V110Z" fill="white" />
			<path
				d="M16 110V109.5H15.5V110H16ZM16 110V110.5H78V110V109.5H16V110ZM16 120H16.5V110H16H15.5V120H16Z"
				fill="#31323A"
				mask="url(#path-34-inside-11_250_12613)"
			/>
			<mask id="path-36-inside-12_250_12613" fill="white">
				<path d="M16 120H78V130H16V120Z" />
			</mask>
			<path d="M16 120H78V130H16V120Z" fill="white" />
			<path
				d="M16 120V119.5H15.5V120H16ZM16 120V120.5H78V120V119.5H16V120ZM16 130H16.5V120H16H15.5V130H16Z"
				fill="#31323A"
				mask="url(#path-36-inside-12_250_12613)"
			/>
			<mask id="path-38-inside-13_250_12613" fill="white">
				<path d="M78 110H140V120H78V110Z" />
			</mask>
			<path d="M78 110H140V120H78V110Z" fill="white" />
			<path
				d="M78 110V109.5H77.5V110H78ZM78 110V110.5H140V110V109.5H78V110ZM78 120H78.5V110H78H77.5V120H78Z"
				fill="#31323A"
				mask="url(#path-38-inside-13_250_12613)"
			/>
			<mask id="path-40-inside-14_250_12613" fill="white">
				<path d="M78 120H140V130H78V120Z" />
			</mask>
			<path d="M78 120H140V130H78V120Z" fill="white" />
			<path
				d="M78 120V119.5H77.5V120H78ZM78 120V120.5H140V120V119.5H78V120ZM78 130H78.5V120H78H77.5V130H78Z"
				fill="#31323A"
				mask="url(#path-40-inside-14_250_12613)"
			/>
			<mask id="path-42-inside-15_250_12613" fill="white">
				<path d="M16 130H78V150H16V130Z" />
			</mask>
			<path d="M16 130H78V150H16V130Z" fill="white" />
			<path
				d="M16 130V129.5H15.5V130H16ZM16 130V130.5H78V130V129.5H16V130ZM16 150H16.5V130H16H15.5V150H16Z"
				fill="#31323A"
				mask="url(#path-42-inside-15_250_12613)"
			/>
			<mask id="path-44-inside-16_250_12613" fill="white">
				<path d="M78 130H140V150H78V130Z" />
			</mask>
			<path d="M78 130H140V150H78V130Z" fill="white" />
			<path
				d="M78 130V129.5H77.5V130H78ZM78 130V130.5H140V130V129.5H78V130ZM78 150H78.5V130H78H77.5V150H78Z"
				fill="#31323A"
				mask="url(#path-44-inside-16_250_12613)"
			/>
			<mask id="path-46-inside-17_250_12613" fill="white">
				<path d="M16 150H78V160H16V150Z" />
			</mask>
			<path d="M16 150H78V160H16V150Z" fill="white" />
			<path
				d="M16 150V149.5H15.5V150H16ZM16 150V150.5H78V150V149.5H16V150ZM16 160H16.5V150H16H15.5V160H16Z"
				fill="#31323A"
				mask="url(#path-46-inside-17_250_12613)"
			/>
			<mask id="path-48-inside-18_250_12613" fill="white">
				<path d="M16 160H78V170H16V160Z" />
			</mask>
			<path d="M16 160H78V170H16V160Z" fill="white" />
			<path
				d="M16 160V159.5H15.5V160H16ZM16 160V160.5H78V160V159.5H16V160ZM16 170H16.5V160H16H15.5V170H16Z"
				fill="#31323A"
				mask="url(#path-48-inside-18_250_12613)"
			/>
			<mask id="path-50-inside-19_250_12613" fill="white">
				<path d="M78 150H140V160H78V150Z" />
			</mask>
			<path d="M78 150H140V160H78V150Z" fill="white" />
			<path
				d="M78 150V149.5H77.5V150H78ZM78 150V150.5H140V150V149.5H78V150ZM78 160H78.5V150H78H77.5V160H78Z"
				fill="#31323A"
				mask="url(#path-50-inside-19_250_12613)"
			/>
			<mask id="path-52-inside-20_250_12613" fill="white">
				<path d="M78 160H140V170H78V160Z" />
			</mask>
			<path d="M78 160H140V170H78V160Z" fill="white" />
			<path
				d="M78 160V159.5H77.5V160H78ZM78 160V160.5H140V160V159.5H78V160ZM78 170H78.5V160H78H77.5V170H78Z"
				fill="#31323A"
				mask="url(#path-52-inside-20_250_12613)"
			/>
			<mask id="path-54-inside-21_250_12613" fill="white">
				<path d="M140 110H202V170H140V110Z" />
			</mask>
			<path d="M140 110H202V170H140V110Z" fill="white" />
			<path
				d="M140 110V109.5H139.5V110H140ZM140 110V110.5H202V110V109.5H140V110ZM140 170H140.5V110H140H139.5V170H140Z"
				fill="#31323A"
				mask="url(#path-54-inside-21_250_12613)"
			/>
			<mask id="path-56-inside-22_250_12613" fill="white">
				<path d="M202 110H264V120H202V110Z" />
			</mask>
			<path
				d="M202 110V109.5H201.5V110H202ZM202 110V110.5H264V110V109.5H202V110ZM202 120H202.5V110H202H201.5V120H202Z"
				fill="#31323A"
				mask="url(#path-56-inside-22_250_12613)"
			/>
			<mask id="path-58-inside-23_250_12613" fill="white">
				<path d="M202 120H264V130H202V120Z" />
			</mask>
			<path
				d="M202 120V119.5H201.5V120H202ZM202 120V120.5H264V120V119.5H202V120ZM202 130H202.5V120H202H201.5V130H202Z"
				fill="#31323A"
				mask="url(#path-58-inside-23_250_12613)"
			/>
			<mask id="path-60-inside-24_250_12613" fill="white">
				<path d="M264 110H326V120H264V110Z" />
			</mask>
			<path d="M264 110H326V120H264V110Z" fill="white" />
			<path
				d="M264 110V109.5H263.5V110H264ZM326 110H326.5V109.5H326V110ZM264 110V110.5H326V110V109.5H264V110ZM326 110H325.5V120H326H326.5V110H326ZM264 120H264.5V110H264H263.5V120H264Z"
				fill="#31323A"
				mask="url(#path-60-inside-24_250_12613)"
			/>
			<mask id="path-62-inside-25_250_12613" fill="white">
				<path d="M264 120H326V130H264V120Z" />
			</mask>
			<path d="M264 120H326V130H264V120Z" fill="white" />
			<path
				d="M264 120V119.5H263.5V120H264ZM326 120H326.5V119.5H326V120ZM264 120V120.5H326V120V119.5H264V120ZM326 120H325.5V130H326H326.5V120H326ZM264 130H264.5V120H264H263.5V130H264Z"
				fill="#31323A"
				mask="url(#path-62-inside-25_250_12613)"
			/>
			<mask id="path-64-inside-26_250_12613" fill="white">
				<path d="M202 130H264V150H202V130Z" />
			</mask>
			<path
				d="M202 130V129.5H201.5V130H202ZM202 130V130.5H264V130V129.5H202V130ZM202 150H202.5V130H202H201.5V150H202Z"
				fill="#31323A"
				mask="url(#path-64-inside-26_250_12613)"
			/>
			<mask id="path-66-inside-27_250_12613" fill="white">
				<path d="M264 130H326V150H264V130Z" />
			</mask>
			<path d="M264 130H326V150H264V130Z" fill="white" />
			<path
				d="M264 130V129.5H263.5V130H264ZM326 130H326.5V129.5H326V130ZM264 130V130.5H326V130V129.5H264V130ZM326 130H325.5V150H326H326.5V130H326ZM264 150H264.5V130H264H263.5V150H264Z"
				fill="#31323A"
				mask="url(#path-66-inside-27_250_12613)"
			/>
			<mask id="path-68-inside-28_250_12613" fill="white">
				<path d="M202 150H264V160H202V150Z" />
			</mask>
			<path
				d="M202 150V149.5H201.5V150H202ZM202 150V150.5H264V150V149.5H202V150ZM202 160H202.5V150H202H201.5V160H202Z"
				fill="#31323A"
				mask="url(#path-68-inside-28_250_12613)"
			/>
			<mask id="path-70-inside-29_250_12613" fill="white">
				<path d="M202 160H264V170H202V160Z" />
			</mask>
			<path
				d="M202 160V159.5H201.5V160H202ZM202 160V160.5H264V160V159.5H202V160ZM202 170H202.5V160H202H201.5V170H202Z"
				fill="#31323A"
				mask="url(#path-70-inside-29_250_12613)"
			/>
			<mask id="path-72-inside-30_250_12613" fill="white">
				<path d="M264 150H326V160H264V150Z" />
			</mask>
			<path d="M264 150H326V160H264V150Z" fill="white" />
			<path
				d="M264 150V149.5H263.5V150H264ZM326 150H326.5V149.5H326V150ZM264 150V150.5H326V150V149.5H264V150ZM326 150H325.5V160H326H326.5V150H326ZM264 160H264.5V150H264H263.5V160H264Z"
				fill="#31323A"
				mask="url(#path-72-inside-30_250_12613)"
			/>
			<mask id="path-74-inside-31_250_12613" fill="white">
				<path d="M264 160H326V170H264V160Z" />
			</mask>
			<path d="M264 160H326V170H264V160Z" fill="white" />
			<path
				d="M264 160V159.5H263.5V160H264ZM326 160H326.5V159.5H326V160ZM264 160V160.5H326V160V159.5H264V160ZM326 160H325.5V170H326H326.5V160H326ZM264 170H264.5V160H264H263.5V170H264Z"
				fill="#31323A"
				mask="url(#path-74-inside-31_250_12613)"
			/>
			<rect width="310" height="20" transform="translate(16 170)" fill="white" />
			<mask id="path-76-inside-32_250_12613" fill="white">
				<path d="M16 170H78V190H16V170Z" />
			</mask>
			<path d="M16 170H78V190H16V170Z" fill="white" />
			<path
				d="M16 170V169.5H15.5V170H16ZM16 170V170.5H78V170V169.5H16V170ZM16 190H16.5V170H16H15.5V190H16Z"
				fill="#31323A"
				mask="url(#path-76-inside-32_250_12613)"
			/>
			<rect width="62" height="20" transform="translate(78 170)" fill="white" />
			<mask id="path-78-inside-33_250_12613" fill="white">
				<path d="M78 170H140V190H78V170Z" />
			</mask>
			<path d="M78 170H140V190H78V170Z" fill="white" />
			<path
				d="M78 170V169.5H77.5V170H78ZM78 170V170.5H140V170V169.5H78V170ZM78 190H78.5V170H78H77.5V190H78Z"
				fill="#31323A"
				mask="url(#path-78-inside-33_250_12613)"
			/>
			<rect width="62" height="20" transform="translate(140 170)" fill="white" />
			<mask id="path-80-inside-34_250_12613" fill="white">
				<path d="M140 170H202V190H140V170Z" />
			</mask>
			<path d="M140 170H202V190H140V170Z" fill="white" />
			<path
				d="M140 170V169.5H139.5V170H140ZM140 170V170.5H202V170V169.5H140V170ZM140 190H140.5V170H140H139.5V190H140Z"
				fill="#31323A"
				mask="url(#path-80-inside-34_250_12613)"
			/>
			<rect width="62" height="20" transform="translate(202 170)" fill="white" />
			<mask id="path-82-inside-35_250_12613" fill="white">
				<path d="M202 170H264V190H202V170Z" />
			</mask>
			<path
				d="M202 170V169.5H201.5V170H202ZM202 170V170.5H264V170V169.5H202V170ZM202 190H202.5V170H202H201.5V190H202Z"
				fill="#31323A"
				mask="url(#path-82-inside-35_250_12613)"
			/>
			<mask id="path-84-inside-36_250_12613" fill="white">
				<path d="M264 170H326V190H264V170Z" />
			</mask>
			<path d="M264 170H326V190H264V170Z" fill="white" />
			<path
				d="M264 170V169.5H263.5V170H264ZM326 170H326.5V169.5H326V170ZM264 170V170.5H326V170V169.5H264V170ZM326 170H325.5V190H326H326.5V170H326ZM264 190H264.5V170H264H263.5V190H264Z"
				fill="#31323A"
				mask="url(#path-84-inside-36_250_12613)"
			/>
			<rect width="310" height="38" transform="translate(16 190)" fill="white" />
			<mask id="path-86-inside-37_250_12613" fill="white">
				<path d="M16 190H78V228H16V190Z" />
			</mask>
			<path d="M16 190H78V228H16V190Z" fill="white" />
			<path
				d="M16 190V189.5H15.5V190H16ZM16 228H15.5V228.5H16V228ZM16 190V190.5H78V190V189.5H16V190ZM78 228V227.5H16V228V228.5H78V228ZM16 228H16.5V190H16H15.5V228H16Z"
				fill="#31323A"
				mask="url(#path-86-inside-37_250_12613)"
			/>
			<mask id="path-88-inside-38_250_12613" fill="white">
				<path d="M78 190H140V228H78V190Z" />
			</mask>
			<path d="M78 190H140V228H78V190Z" fill="white" />
			<path
				d="M78 190V189.5H77.5V190H78ZM78 228H77.5V228.5H78V228ZM78 190V190.5H140V190V189.5H78V190ZM140 228V227.5H78V228V228.5H140V228ZM78 228H78.5V190H78H77.5V228H78Z"
				fill="#31323A"
				mask="url(#path-88-inside-38_250_12613)"
			/>
			<mask id="path-90-inside-39_250_12613" fill="white">
				<path d="M140 190H202V228H140V190Z" />
			</mask>
			<path d="M140 190H202V228H140V190Z" fill="#DBFFC8" />
			<path
				d="M140 190V189.5H139.5V190H140ZM140 228H139.5V228.5H140V228ZM140 190V190.5H202V190V189.5H140V190ZM202 228V227.5H140V228V228.5H202V228ZM140 228H140.5V190H140H139.5V228H140Z"
				fill="#31323A"
				mask="url(#path-90-inside-39_250_12613)"
			/>
			<mask id="path-92-inside-40_250_12613" fill="white">
				<path d="M202 190H264V228H202V190Z" />
			</mask>
			<path
				d="M202 190V189.5H201.5V190H202ZM202 228H201.5V228.5H202V228ZM202 190V190.5H264V190V189.5H202V190ZM264 228V227.5H202V228V228.5H264V228ZM202 228H202.5V190H202H201.5V228H202Z"
				fill="#31323A"
				mask="url(#path-92-inside-40_250_12613)"
			/>
			<rect x="264.25" y="190.25" width="61.5" height="37.5" fill="white" stroke="#31323A" strokeWidth="0.5" />
			<path
				d="M156.165 201.183C156.088 201.147 156 201.203 156 201.289V216.691C156 216.736 156.026 216.776 156.066 216.796L170.728 223.87C170.805 223.908 170.895 223.851 170.895 223.766V208.134C170.895 208.088 170.868 208.047 170.828 208.028L156.165 201.183Z"
				fill="#BDFF9C"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M170.994 208.141C170.954 208.16 170.928 208.201 170.928 208.246V223.819C170.928 223.904 171.015 223.96 171.092 223.925L185.754 217.231C185.795 217.212 185.822 217.171 185.822 217.126L185.998 201.227C185.999 201.142 185.91 201.084 185.832 201.121L170.994 208.141Z"
				fill="white"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M156.078 201.103C156.061 201.112 156.061 201.137 156.078 201.145L170.918 208.149C170.924 208.151 170.931 208.151 170.938 208.149L185.956 201.05C185.973 201.042 185.973 201.016 185.955 201.008L170.938 194.005C170.931 194.002 170.924 194.002 170.918 194.005L156.078 201.103Z"
				fill="white"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M161.95 198.317L177.031 205.295L177.094 212.432L180.543 210.681L180.566 203.608L165.662 196.567L161.95 198.317Z"
				fill="#DBFFC8"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M177.032 205.293L180.567 203.606L180.543 210.679L177.095 212.43L177.032 205.293Z"
				fill="#BDFF9C"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M161.95 198.317L177.031 205.295L177.094 212.432L180.543 210.681L180.566 203.608L165.662 196.567L161.95 198.317Z"
				fill="#DBFFC8"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<path
				d="M177.032 205.293L180.567 203.606L180.543 210.679L177.095 212.43L177.032 205.293Z"
				fill="#BDFF9C"
				stroke="black"
				strokeWidth="0.465116"
				strokeMiterlimit="10"
			/>
			<g clipPath="url(#clip0_250_12613)">
				<path
					d="M10.1016 22.419L8.43262 22.433L8.43262 12.2486L10.1016 12.0303L10.1016 15.7927C10.6328 15.1965 11.6006 14.6647 12.9348 14.6536C15.4505 14.6326 16.939 16.4136 16.939 18.5709C16.939 20.7283 15.4505 22.5341 12.9348 22.555C11.6006 22.5662 10.6258 22.0506 10.1016 21.4632L10.1016 22.419ZM10.0192 18.6914C10.0192 20.0812 11.1904 21.1241 12.6998 21.1116C14.2093 21.099 15.3541 20.1964 15.3541 18.5895C15.3541 16.9827 14.1339 16.0944 12.6998 16.1064C11.1851 16.119 10.0192 17.1868 10.0192 18.5766L10.0192 18.6914Z"
					fill="black"
				/>
				<path
					d="M17.3848 20.1561C17.3848 18.8236 18.4402 18.024 20.1916 17.787L23.3596 17.3678L23.3596 17.3105C23.3596 16.5877 22.7477 16.0459 21.3837 16.0572C20.2565 16.0666 19.2712 16.6093 18.9924 17.3469L17.6144 16.7217C18.0738 15.4482 19.6709 14.592 21.4381 14.5773C23.6927 14.5585 24.9725 15.5162 24.9725 17.3257L24.9725 20.5196C24.9725 20.9518 25.1636 21.1385 26.0559 20.932L26.0559 22.2752C24.5026 22.6182 23.7908 22.0215 23.5559 21.2721C22.9055 21.9715 21.7782 22.4705 20.416 22.4819C18.7365 22.4959 17.3848 21.7109 17.3848 20.1507L17.3848 20.1561ZM23.3596 18.7344L20.4703 19.1171C19.4973 19.2382 19.01 19.4933 19.01 20.1246C19.01 20.7558 19.5955 21.0881 20.5527 21.0801C21.8063 21.0697 23.3596 20.4757 23.3596 19.3656L23.3596 18.729L23.3596 18.7344Z"
					fill="black"
				/>
				<path
					d="M30.3735 14.5081C32.2775 14.4922 33.6397 15.625 34.099 16.8335L32.7631 17.6408C32.4738 16.7609 31.5534 15.9724 30.356 15.9824C28.8676 15.9948 27.7298 16.9314 27.7298 18.4808C27.7298 20.0303 28.8676 20.9479 30.356 20.9355C31.5482 20.9256 32.4686 20.1217 32.7631 19.2369L34.0815 20.0509C33.6116 21.2563 32.2757 22.3937 30.3718 22.4095C27.991 22.4294 26.1309 20.8398 26.1309 18.4942C26.1309 16.1485 27.9927 14.5279 30.3735 14.5081Z"
					fill="black"
				/>
				<path
					d="M41.1312 19.4613L42.4653 20.1854C42.0218 21.3781 40.6438 22.4996 38.6855 22.516C36.2556 22.5362 34.4727 20.946 34.4727 18.6004C34.4727 16.2547 36.196 14.6353 38.6855 14.6145C40.5509 14.599 41.8815 15.5904 42.3847 17.0549C42.5109 17.4305 42.5933 17.8046 42.6039 18.2313L36.054 19.0893C36.2784 20.3051 37.3233 21.0478 38.6803 21.0365C39.8899 21.0264 40.7806 20.3824 41.1259 19.4559L41.1312 19.4613ZM36.1241 17.7957L40.7683 17.1706C40.7683 17.1706 40.763 17.142 40.7139 17.0742C40.7034 17.0636 40.6982 17.051 40.6859 17.0404C40.2967 16.5038 39.5639 16.0598 38.5961 16.0679C37.4425 16.0775 36.4415 16.6776 36.1241 17.7957Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_250_12613">
					<rect width="35.0295" height="11.1366" fill="white" transform="matrix(0.999965 -0.00833543 -4.35879e-10 1 8 11.6711)" />
				</clipPath>
			</defs>
		</svg>
	);
};
